function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip786)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.82205 1.269C5.1011 1.02282 5.12783 0.597054 4.88162 0.317954C4.63549 0.0388543 4.20963 0.0121707 3.93053 0.258343C1.46117 2.43647 0.0449219 5.56788 0.0449219 8.84961C0.0449219 9.22174 0.346617 9.52343 0.71875 9.52343C1.09088 9.52343 1.39258 9.22174 1.39258 8.84961C1.39258 5.95444 2.64257 3.19143 4.82205 1.269ZM19.0695 0.258343C18.7903 0.0121707 18.3645 0.0388992 18.1184 0.317954C17.8722 0.597054 17.8989 1.02282 18.178 1.269C20.3574 3.19143 21.6074 5.95444 21.6074 8.84961C21.6074 9.22174 21.9091 9.52343 22.2812 9.52343C22.6534 9.52343 22.9551 9.22174 22.9551 8.84961C22.9551 5.56788 21.5388 2.43647 19.0695 0.258343ZM5.80112 2.20162C3.85587 3.87132 2.74023 6.2944 2.74023 8.84961C2.74023 9.22174 3.04193 9.52343 3.41406 9.52343C3.7862 9.52343 4.08789 9.22174 4.08789 8.84961C4.08789 6.68797 5.03224 4.6376 6.67885 3.22422C6.96123 2.98182 6.99366 2.55641 6.75126 2.27403C6.50887 1.99161 6.08341 1.95922 5.80112 2.20162ZM17.1989 2.20162C16.9165 1.95922 16.4911 1.99165 16.2487 2.27403C16.0063 2.55641 16.0388 2.98182 16.3211 3.22422C17.9678 4.6376 18.9121 6.68797 18.9121 8.84961C18.9121 9.22174 19.2138 9.52343 19.5859 9.52343C19.9581 9.52343 20.2598 9.22174 20.2598 8.84961C20.2598 6.2944 19.1441 3.87132 17.1989 2.20162ZM12.8477 18.957H10.1523C9.78021 18.957 9.47852 19.2587 9.47852 19.6309V20.9785C9.47852 22.0932 10.3854 23 11.5 23C12.6146 23 13.5215 22.0932 13.5215 20.9785V19.6309C13.5215 19.2587 13.2198 18.957 12.8477 18.957Z",
  fill: "url(#paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.062 19.1543C18.4512 17.5435 17.5642 15.4018 17.5642 13.1238V8.84961C17.5642 5.73342 15.2015 3.15909 12.1735 2.8228V0.673828C12.1735 0.301695 11.8718 0 11.4997 0C11.1276 0 10.8259 0.301695 10.8259 0.673828V2.8228C7.79788 3.15909 5.43526 5.73342 5.43526 8.84961V13.1238C5.43526 15.4018 4.54818 17.5434 2.93742 19.1543C2.52041 19.571 2.80517 20.3047 3.41377 20.3047H19.5856C20.1925 20.3047 20.4801 19.5721 20.062 19.1543Z",
  fill: "url(#paint1_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear786",
  x1: 11.5,
  y1: 23,
  x2: 11.5,
  y2: 0.089841,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ADDCFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5028,
  stopColor: "#EAF6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00ACFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear786",
  x1: 11.4998,
  y1: 20.3047,
  x2: 11.4998,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00ACFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0078FF"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip786"
}, /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  fill: "white"
})));

function SvgBellBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellBlue);
export default __webpack_public_path__ + "static/media/bellBlue.bbf6ea42.svg";
export { ForwardRef as ReactComponent };